/**
 * ═══ L'ADRESSE D'UN FICHIER, QUELLE QUE SOIT LA FORME OÙ IL EST RANGÉ ═══
 *
 * ⚠️ DEUX FORMES COEXISTENT, ET UNE SEULE EST UNE ADRESSE. Ce que le panneau de la V2
 * écrit est l'adresse publique complète rendue par le téléversement (voir
 * `api/upload.ts`). Ce que la REPRISE d'un événement V1 recopie est la valeur brute de
 * la V1, c'est-à-dire une CLÉ de fichier nue : `42685c93-c862-4a29-9c09-fa2e0b6f59c0`.
 *
 * ⚠️ ET C'EST LA V1 QUI POSAIT LE PRÉFIXE, à chacun de ses écrans, à la main
 * (`shared/footer.jsx`, `appRouter.jsx`, `RecapPDF.jsx`… la même expression recopiée
 * six fois). La V2 posait la valeur telle quelle : le navigateur résolvait la clé
 * contre l'adresse du site, donc `https://event.dev.gayakoa.com/42685c93…`, qui
 * ne désigne rien. Vu sur l'événement `sportachatété2025` juste après sa reprise :
 * bandeau d'en-tête et bandeau de pied tous les deux vides, sans le moindre message.
 *
 * La règle est celle de la V1, à un seul endroit : si c'est déjà une adresse, on n'y
 * touche pas ; sinon c'est une clé, et elle vit dans le seau public.
 */

/** Le seau public, celui que la V1 nomme en clair dans chacun de ses écrans. */
const PUBLIC_BUCKET =
  "https://gayakoa-files-eu-west-1-public.s3.eu-west-1.amazonaws.com";

/**
 * @param value ce que le réglage porte : une adresse complète, une clé nue, ou rien.
 * @returns l'adresse à servir, ou `""` s'il n'y a rien à servir.
 */
export function fileUrl(value: string | undefined | null): string {
  const raw = (value ?? "").trim();
  if (!raw) return "";

  /**
   * ⚠️ TESTÉ SUR LE DÉBUT, pas avec `includes("https")` comme la V1. Sa version dit
   * vrai pour une clé qui contiendrait « https » n'importe où — improbable sur un
   * UUID, mais c'est une garde qui ne coûte rien de faire juste. Les données en
   * `data:` sont laissées passer pour la même raison : ce sont déjà des adresses.
   */
  if (/^(https?:|data:|blob:|\/\/)/i.test(raw)) return raw;

  /* Une clé peut arriver avec sa barre de tête si quelqu'un l'a recopiée à la main. */
  return `${PUBLIC_BUCKET}/${raw.replace(/^\/+/, "")}`;
}
